import FileUploader from "./comps/FileUploader.svelte"
import type { UploadResult, Meta, UppyFile } from "@uppy/core"

/** The result Uppy hands to `onAllComplete`. */
export type UploadCompletion = UploadResult<Meta, Record<string, never>>
/** One file as Uppy tracks it, including the tus upload URL once it has one. */
export type UploadedFile = UppyFile<Meta, Record<string, never>>

/**
 * The tus upload id tusd assigned to a file, taken from the upload URL tusd returned.
 * It is the same id tusd hands the API in its hook calls, so the API can be asked what
 * became of this exact upload. Null until the upload was created.
 */
export function getTusUploadId(file: UploadedFile | undefined): string | null {
	const url = (file as { tus?: { uploadUrl?: string } } | undefined)?.tus?.uploadUrl ?? file?.uploadURL
	if (!url) return null
	const lastSegment = url.split("?")[0].split("/").filter(Boolean).pop()
	if (!lastSegment) return null
	try {
		return decodeURIComponent(lastSegment)
	} catch {
		return lastSegment
	}
}

export { FileUploader }
export { UploadError } from "./model/errors"
